import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Pagination, Button, Modal, useToaster, Notification, Dropdown } from "rsuite";
import { useGetExportData, useScenarioPlanningData, useUpdateForecast, useUpdateReviewdForecastData } from "../../services/redux/hooks/useForecast";
import { DATA_TABLE } from "../../utils/tableheaders";
import { formatNumber,convertVhToPx } from "../../utils/formatter";
import CustomerDataTable from "./customerDataTable";
import { CSVLink } from "react-csv";
import { FilterTable, UpdateForeCast } from "../../services/interface/IAlerts";
import CustomCell from "./CustomCell";
import { IRoot } from "../../services/interface/IHome";
import { IAlertRow } from "../../services/interface/IForecast";
import { setApplyForecastFilter, setMaterial, setPlant, setSelectedGbpFilter, setSelectionFlag } from "../../services/redux/reducer/filter.reducer";
import CustomLoader from "../../common/CustomLoader/CustomLoader";

const { Column, HeaderCell, Cell } = Table;

const ForecastAlertTable = ({tableHeight}:any) => {
    const dispatch = useDispatch();
    const toaster = useToaster();
    const exportFullRef = useRef<any>();
    const [loading, setLoading] = useState(false);
    const [sortColumn, setSortColumn] = useState('');
    const [sortType, setSortType] = useState();
    const [isOpenModal, setOpenModal] = useState(false);
    // pagination
    const [monthNumber, setMonthNumber] = useState<any>(null);
    const [selectedFilterData, setSelectedFilterData] = useState<FilterTable>({
        orderBy: "AnnualRevenue",
        order: "desc",
        pageNumber: 1,
        pageSize: 100,
        monthNumber: [0, 1],
    });
    const [total, setTotal] = useState<number>(0);
    // Filter all available options
    const [gbpfilter, setGbpFilter] = useState<any>({
        plant: [],
        l2: [],
        l3: [],
        materialDescription: [],
        material: [],
        mrpType: [],
        futureSegmentation: [],
        vendorName: [],
        clustername: [],
        alerts: [],
        reviewedFlag: [],
        poAlert: [],
        adjustedLogic: []
    });
    const [exportData, setExportData] = useState<any>([]);
    const [exportAllData, setExportALLData] = useState<[]>([]);
    // const [exportGainData, setExportGainData] = useState<any>([]);
    const [exportAdjustedData, setExportAdjustedData] = useState<any>([]);
    // Alerts - Table Data
    const [forecastTableData, setForecastTableData] = useState<[]>([]);
    const [selectedSKUL, setSelectedSKUL] = useState<any>();
    const [changedAdjustedForecast, setChangedAdjustedForecast] =
        useState<UpdateForeCast>({ data: [] });
    const [selectedRow, setSelectedRow] = useState<IAlertRow[]>([]);
    const [selectedRowData, setSelectedRowData] = useState<IAlertRow[]>([]);
    // const [tableSelection, setTableSelection] = useState<boolean>(false);
    const selectionFlag = useSelector((state: IRoot) => state.filter.selectionFlag);
    const windowSize = useSelector((state: IRoot) => state.filter.windowSize);
    const selectedGBPFilter = useSelector((state: IRoot) => state.filter.selectedGBPFilter);
    const applyFilter = useSelector((state:IRoot)=>state.filter.applyForecastFilter);
    const alertType = new URLSearchParams(location.search).get("alert");

    const handleSortColumn = (sortColumn: any, sortType: any) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
    };
    const splitParts = (str: string) => {
        return String(str).split(/(\d+)/).map((part: string, index: number) => {
            return index % 2 === 1 ? parseInt(part, 10) : part;
        });
    };

    const naturalSort = (a: { [x: string]: string; }, b: { [x: string]: string; }) => {
        const aParts = splitParts(a[sortColumn]);
        const bParts = splitParts(b[sortColumn]);

        for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
            const aPart = aParts[i];
            const bPart = bParts[i];

            if (aPart !== bPart) {
                if (typeof aPart === 'number' && typeof bPart === 'number') {
                    return aPart - bPart;
                }
                return aPart > bPart ? 1 : -1;
            }
        }
        return 0;
    };

    const getSortedData = () => {
        if (sortColumn && sortType) {
            return [...forecastTableData].sort((a, b) => {
                const result = naturalSort(a, b);
                return sortType === 'asc' ? result : -result;
            });
        }
        return forecastTableData;
    };


    const sortedData = getSortedData();
    const { mutate: mutateForecastTable, isError, error, isSuccess, data: forecastData } = useScenarioPlanningData();
    const { mutate: mutateReviewedForecastData, isError: isReviewdError, error: reviewError, isSuccess: isReviewdSuccess, data: reviewedData } = useUpdateReviewdForecastData();
    const { mutate: mutateGetExportData, isError: isGetExportError, error: getExportError, isSuccess: isGetExportSuccess, data: exportCompleteData } = useGetExportData();
    const { mutate: mutateUpdateForecast, isError: isUpdateError, error: updateError, isSuccess: isUpdateForecastSuccess, data: updateForecastData } = useUpdateForecast();

    const getScenarioPlanningTableData = (data: any) => {
        if (!selectionFlag) {
            let payload = {
                ...gbpfilter,
                ...selectedGBPFilter,
                orderBy: "annualRevenue",
                order: "desc",
                pageNumber: data?.pageNumber ? data?.pageNumber : 1,
                pageSize: 100,
            };
            mutateForecastTable(payload);
        }
    }

    const handleReviewChange = async (data: any) => {
        mutateReviewedForecastData(data);
    };

    const handleRowSelection = (data: any) => {
        let index = selectedRow.indexOf(data?.SKUl);
        if (index !== -1) {
            setSelectedRow([]);
            setSelectedRowData([]);
            dispatch(setPlant([]));
            dispatch(setMaterial([]));
            dispatch(setSelectionFlag(false));
            dispatch(setApplyForecastFilter({"status" : true, "rowNo" : index}));
        } else {
            setSelectedRow([data?.SKUl]);
            setSelectedRowData([data]);
            dispatch(setPlant([data?.plant]));
            dispatch(setMaterial([data?.material]));
            dispatch(setSelectionFlag(true));
            dispatch(setApplyForecastFilter({"status": true, "rowNo": index }));
        }
    }

    const getExportDataHandler = async () => {
        toaster.push(message, { placement: "topCenter" });
        let payload = {
            ...selectedGBPFilter,
            monthNumber: selectedFilterData?.monthNumber,
        };
        const response = await mutateGetExportData(payload);
        if(response.data){
            prepareExport(response.data?.data,1);
        }
    }

    const prepareExport = (data: any, type: number = 0) => {
        let finalData: any = [];
        if(Array.isArray(data)){
            data?.forEach((element: any) => {
                let obj = {
                    service_center_cluster_name: element.service_center_cluster_name,
                    PLANT_PLANT: element.PLANT_PLANT,
                    MATERIAL_MATERIAL: element.MATERIAL_MATERIAL,
                    vendor_name: element.vendor_name,
                    Alerts: element.Alerts,
                    forecast_date: element?.forecast_date?.slice(0, 10),
                    standard_price: `$${formatNumber(
                        (element.standard_price || 0)?.toFixed(2)
                    )}`,
                    annualRevenue: `$${formatNumber(
                        (element.annualRevenue || 0)?.toFixed(2)
                    )}`,
                    AvgDemand_Last12Months: formatNumber(
                        (element.AvgDemand_Last12Months || 0)?.toFixed(0)
                    ),
                    AvgDemand_Last8Months: formatNumber(
                        (element.AvgDemand_Last8Months || 0)?.toFixed(0)
                    ),
                    AvgDemand_Last4Months: formatNumber(
                        (element.AvgDemand_Last4Months || 0)?.toFixed(0)
                    ),
                    CurrentMonthDemandLY: formatNumber(
                        (element.CurrentMonthDemandLY || 0)?.toFixed(0)
                    ),
                    AvgForecast_Last4Months: formatNumber(
                        (element.AvgForecast_Last4Months || 0)?.toFixed(0)
                    ),
                    Last4Month_Accuracy: `${(
                        (element.Last4Month_Accuracy || 0) * 100
                    )?.toFixed(0)}%`,
                    Last4Month_BIAS: element.Last4Month_BIAS,
                    Lag1_Foreast: formatNumber((element.Lag1_Foreast || 0)?.toFixed(0)),
                    Lag2_Foreast: formatNumber((element.Lag2_Foreast || 0)?.toFixed(0)),
                    forecastMonth0: formatNumber((element.forecastMonth0 || 0)?.toFixed(0)),
                    CurrentMonthOpenSalesQty: formatNumber((element.CurrentMonthOpenSalesQty || 0)?.toFixed(0)),
                    AdjustedForecast0: formatNumber(
                        (element.AdjustedForecast0 || 0)?.toFixed(0)
                    ),
                    forecastMonth1: formatNumber(
                        (element.forecastMonth1 || 0)?.toFixed(0)
                    ),
                    AdjustedForecast1: formatNumber(
                        (element.AdjustedForecast1 || 0)?.toFixed(0)
                    ),
                    Comments: element.Comments,
                    vendor_number: element.vendor_number,
                    material_description: element.material_description,
                    isReviewed: element.isReviewed === 0 ? 'No' : element.isReviewed === 2 ? 'In Progress' : 'Yes',
                };
                finalData.push(obj);
            });
        }
        if (type === 0) {
            setExportData(finalData);
        } else if (type === 1) {
            setExportALLData(finalData);
        } else if (type === 2) {
            setExportAdjustedData(finalData);
        }
    };

    const getCurrentPageDataHandler = () => {
        toaster.push(message, { placement: "topCenter" });
    }

    const handleAdjustedForecast = (data: any) => {
        let found = false,
            localData = changedAdjustedForecast.data;
        localData.forEach((element: any) => {
            if (element?.SKUl === data?.SKUl) {
                if (data?.type === 0) {
                    element.adjustedForecast0 = data?.adjustedForecast;
                } else if (data?.type === 1) {
                    element.adjustedForecast1 = data?.adjustedForecast;
                } else {
                    element.Comments = data?.Comments;
                }
                element.previousAdjustedForecast0 = data?.Forecast0;
                element.previousAdjustedForecast1 = data?.Forecast1;
                found = true;
            }
        });

        if (!found) {
            localData.push({
                SKUl: data?.SKUl,
                adjustedForecast0:
                    data?.type === 0 ? data?.adjustedForecast : data?.Forecast0,
                adjustedForecast1:
                    data?.type === 1 ? data?.adjustedForecast : data?.Forecast1,
                previousAdjustedForecast0: data?.Forecast0,
                previousAdjustedForecast1: data?.Forecast1,
                prevForecast0: data?.prevForecast0,
                prevForecast1: data?.prevForecast1,
                userOverride: 0,
                Comments:
                    data?.type === 2
                        ? data?.Comments
                        : data?.Comments
                            ? data?.Comments
                            : "",
            });
        }

        let filteredData: any = localData;
        if (data?.type !== 2) {
            filteredData = localData.filter(
                (element: any) =>
                    element?.adjustedForecast0 !== element?.previousAdjustedForecast0 ||
                    element?.adjustedForecast1 !== element?.previousAdjustedForecast1
            );

            if (filteredData?.length !== 0) {
                filteredData.forEach((value: any) => {
                    value.userOverride =
                        value?.adjustedForecast0 === value?.prevForecast0 &&
                            value?.adjustedForecast1 === value?.prevForecast1
                            ? 0
                            : 1;
                });
            }
        }

        // setSaveButton(filteredData.length !== 0 || data?.type === 2 ? false : true);
        setChangedAdjustedForecast({ data: filteredData });
    };

    const getTableData=()=>{
        const payload = {
            ...gbpfilter,
            ...selectedGBPFilter,
            order: "desc",
            orderBy: "annualRevenue",
            pageNumber: 1,
            pageSize: 100
        }
        mutateForecastTable(payload);
    }

    const adjustForecastHandler = () => {
        mutateUpdateForecast(changedAdjustedForecast?.data);
    }


    useEffect(() => {
        if (exportAllData?.length !== 0) {
          exportFullRef?.current?.link.click();
        }
      }, [exportAllData]);

    useEffect(() => {
        if (isReviewdSuccess) {
            getScenarioPlanningTableData({
                // monthNumber: props?.monthNumber,
                pageNumber: selectedFilterData.pageNumber,
            });
        }
    }, [isReviewdSuccess]);

    useEffect(() => {
        if(!applyFilter.status && applyFilter.rowNo == -1){
            const payload = {
                ...gbpfilter,
                ...selectedGBPFilter,
                alerts: [alertType],
                order: "desc",
                orderBy: "annualRevenue",
                pageNumber: 1,
                pageSize: 100
            };
            mutateForecastTable(payload);
        }
        else{
            if (applyFilter.status || applyFilter.rowNo === -1) {
                if (!selectionFlag) {

                    let existingAlerts = selectedGBPFilter.alerts || [];
        
                    if (!existingAlerts.includes(alertType)) {
                        existingAlerts = [...existingAlerts, alertType];
                    }
        
                    const payload = {
                        ...gbpfilter,
                        ...selectedGBPFilter,
                        alerts: existingAlerts,
                        order: "desc",
                        orderBy: "annualRevenue",
                        pageNumber: 1,
                        pageSize: 100
                    };
                    mutateForecastTable(payload);
                }
            }
        } 
    }, [applyFilter, alertType]);

    useEffect(() => {
        setLoading(true);
        if (isSuccess) {
            setForecastTableData(forecastData?.data);
            prepareExport(forecastData?.data, 0);
            setTotal(forecastData?.count);
            setLoading(false);
        }
        if (isSuccess) {
            setLoading(false);
        }
    }, [forecastData]);

    useEffect(() => {
        setLoading(true);
        if (isUpdateForecastSuccess) {
            getTableData();
            setLoading(false)
        }
    }, [isUpdateForecastSuccess, updateForecastData]);

    useEffect(()=>{
        if(applyFilter.status === false){
            setSelectedRow([]);
            setSelectedRowData([]);
            dispatch(setPlant([]));
            dispatch(setMaterial([]));
            dispatch(setSelectionFlag(false));
        }   
    },[applyFilter.status]);

    return (
        <>
            <div>
                <Table
                    height={convertVhToPx(tableHeight)}
                    loading={loading}
                    bordered
                    data={loading ? [] : sortedData}
                    sortColumn={sortColumn}
                    sortType={sortType}
                    onSortColumn={handleSortColumn}
                    headerHeight={70}
                    shouldUpdateScroll={false}
                    cellBordered
                    className="table-container"
                    rowClassName={(rowData, rowIndex) => {
                        let className = rowIndex % 2 === 0 ? 'db-tablebg' : '';
                        if (rowData !== undefined && selectedRow.includes(rowData["SKUl"] || "")) {
                            className += ' rs-row-selection';
                        }
                        else if(selectedRow.length > 0){
                            className  += ' rs-row-nonselection'
                        }
                        return className;
                    }}
                >
                    {DATA_TABLE?.map((value, index) => {
                        const width = ["AvgDemand_Last12Months", "AdjustedForecast1","AdjustedForecast0"].includes(value.key) ? 190 :
                            index === 0 ? 80 :
                            index === DATA_TABLE?.length - 1 ? 100 : 180;
                        const isFixed = index === 0 ? true : false;
                        const right = index >= DATA_TABLE.length - 2 ? 'right' : false;
                        return <Column
                            key={value.key}
                            minWidth={width}
                            align="left"
                            fixed={isFixed || right} sortable flexGrow={1}>
                            <HeaderCell className="font-semibold table-header-title" style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                <div className="header-content font-semibold table-header-title">
                                    {value.label}
                                </div>
                            </HeaderCell>
                            <CustomCell
                                foreCastingChange={(data: any) => {
                                    handleAdjustedForecast(data);
                                }}
                                handleReviewChange={(data: any) => {
                                    handleReviewChange(data);
                                }}
                                handleRowSelection={(data: any) => {
                                    handleRowSelection(data);
                                }}
                                setopenmodal={(data: any) => {
                                    setOpenModal(true);
                                    setSelectedSKUL(data)
                                }}
                                dataKey={value.key}
                            />
                        </Column>
                    })}
                </Table>
            </div>
            <div className="flex grow-0 p-[5px] items-center justify-between">
                <div className="w-[85%] flex justify-center">
                    <Pagination
                        layout={['pager', 'skip']}
                        prev
                        next
                        first
                        last
                        total={total}
                        limit={selectedFilterData?.pageSize}
                        size={"sm"}
                        activePage={selectedFilterData?.pageNumber}
                        onChangePage={(page: number) => {
                            setSelectedFilterData({
                                ...selectedFilterData,
                                pageNumber: page,
                                monthNumber: monthNumber
                            })
                            getScenarioPlanningTableData({
                                pageNumber: page,
                                monthNumber: monthNumber
                            })
                        }}
                    />
                </div>
                <div className="w-[15%] flex justify-evenly 2xl:gap-1">
                    <Button onClick={adjustForecastHandler} className="bg-[#949494] text-white px-[20px] h-[30px] rounded font-semibold btn-text">
                        Save
                    </Button>
                    <Dropdown
                        className="btn-text font-semibold"
                        title="Export"
                        trigger="hover"
                        placement="leftEnd"
                    >
                        <Dropdown.Item onClick={getCurrentPageDataHandler}>
                            <CSVLink
                                data={exportData}
                                headers={DATA_TABLE}
                                filename={"ForeCast100"}
                            >
                                Export This Page
                            </CSVLink>
                        </Dropdown.Item>
                        <Dropdown.Item className="hidden">
                            <CSVLink
                                data={exportAllData}
                                ref={exportFullRef}
                                headers={DATA_TABLE}
                                filename={"ForeCastComplete"}
                            ></CSVLink>
                        </Dropdown.Item>
                        <Dropdown.Item onClick={getExportDataHandler}>
                            Export Complete Data
                        </Dropdown.Item>
                    </Dropdown>
                </div>
            </div>
            <Modal size={'50vw'} open={isOpenModal} className="border-[1px] rounded-md custom-modal"
                onClose={() => {
                    setOpenModal(false); setSelectedSKUL(null)
                }}>
                <Modal.Body>
                    <div className="text-center mb-2">
                        <span className="text-fs20 text-black font-semibold">Customer Level Data</span>
                    </div>
                    <div className="flex mb-2">
                        <div className="text-fs16 flex p-[1%] border border-[#BEBEBE] w-[6vw] font-bold">Item ID</div>
                        <div className="text-fs16 flex p-[1%] border border-[#BEBEBE] w-[6vw]">{`${selectedSKUL?.split('_')[0]}`}</div>
                        <div className="text-fs16 flex p-[1%] border border-[#BEBEBE] w-[6vw] font-bold">DC</div>
                        <div className="text-fs16 flex p-[1%] border border-[#BEBEBE] w-[6vw]">{`${selectedSKUL?.split('_')[1]}`}</div>
                    </div>
                    <CustomerDataTable SKUl={selectedSKUL} />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setOpenModal(false); setSelectedSKUL(null) }} className="bg-[#949494] 
                        text-fs16 font-semibold text-white focus:bg-[#949494]" appearance="subtle">
                        Close
                    </Button>

                </Modal.Footer>
            </Modal>
        </>
    );
};

const message = (
    <Notification type={"info"} header={`Exporting...`} closable>
        <p>Your file is being created. It will be download automatically</p>
    </Notification>
);

export default ForecastAlertTable;